import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/site";

export const MobileReserveBar = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 72, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 72, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-ivory/90 backdrop-blur-xl border-t border-sage/15 px-5 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
          data-testid="mobile-reserve-bar"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-[0.18em] text-sage font-medium">
                Three villas only
              </div>
              <div className="font-serif text-base text-charcoal leading-snug truncate">
                Dates fill fast
              </div>
            </div>
            <a
              href={buildWhatsAppLink("book")}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 inline-flex items-center gap-2 bg-sage text-ivory px-5 py-3 rounded-full text-sm font-medium hover:bg-sage-700 transition-colors"
              data-testid="mobile-reserve-cta"
            >
              <MessageCircle size={16} strokeWidth={1.75} />
              Reserve your dates
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileReserveBar;
